"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeFullViewportWidth = exports.sizeFullViewportHeight = exports.sizeFluid = exports.size960 = exports.size90 = exports.size880 = exports.size800 = exports.size8 = exports.size720 = exports.size70 = exports.size660 = exports.size66 = exports.size640 = exports.size60 = exports.size580 = exports.size58 = exports.size540 = exports.size500 = exports.size50 = exports.size5 = exports.size480 = exports.size48 = exports.size44 = exports.size42 = exports.size400 = exports.size40 = exports.size4 = exports.size380 = exports.size38 = exports.size36 = exports.size34 = exports.size320 = exports.size32 = exports.size300 = exports.size30 = exports.size28 = exports.size276 = exports.size260 = exports.size26 = exports.size252 = exports.size240 = exports.size24 = exports.size228 = exports.size22 = exports.size200 = exports.size20 = exports.size2 = exports.size180 = exports.size18 = exports.size160 = exports.size140 = exports.size1280 = exports.size125 = exports.size12 = exports.size110 = exports.size100 = exports.size10 = void 0;

const size2 = '2px';
exports.size2 = size2;
const size4 = '4px';
exports.size4 = size4;
const size5 = '5px';
exports.size5 = size5;
const size8 = '8px';
exports.size8 = size8;
const size10 = '10px';
exports.size10 = size10;
const size12 = '12px';
exports.size12 = size12;
const size18 = '18px';
exports.size18 = size18;
const size20 = '20px';
exports.size20 = size20;
const size22 = '22px';
exports.size22 = size22;
const size24 = '24px';
exports.size24 = size24;
const size26 = '26px';
exports.size26 = size26;
const size28 = '28px';
exports.size28 = size28;
const size30 = '30px';
exports.size30 = size30;
const size32 = '32px';
exports.size32 = size32;
const size34 = '34px';
exports.size34 = size34;
const size36 = '36px';
exports.size36 = size36;
const size38 = '38px';
exports.size38 = size38;
const size40 = '40px';
exports.size40 = size40;
const size42 = '42px';
exports.size42 = size42;
const size44 = '44px';
exports.size44 = size44;
const size48 = '48px';
exports.size48 = size48;
const size50 = '50px';
exports.size50 = size50;
const size58 = '58px';
exports.size58 = size58;
const size60 = '60px';
exports.size60 = size60;
const size66 = '66px';
exports.size66 = size66;
const size70 = '70px';
exports.size70 = size70;
const size90 = '90px';
exports.size90 = size90;
const size100 = '100px';
exports.size100 = size100;
const size110 = '110px';
exports.size110 = size110;
const size125 = '125px';
exports.size125 = size125;
const size140 = '140px';
exports.size140 = size140;
const size160 = '160px';
exports.size160 = size160;
const size180 = '180px';
exports.size180 = size180;
const size200 = '200px';
exports.size200 = size200;
const size228 = '228px';
exports.size228 = size228;
const size240 = '240px';
exports.size240 = size240;
const size252 = '252px';
exports.size252 = size252;
const size260 = '260px';
exports.size260 = size260;
const size276 = '276px';
exports.size276 = size276;
const size300 = '300px';
exports.size300 = size300;
const size320 = '320px';
exports.size320 = size320;
const size380 = '380px';
exports.size380 = size380;
const size400 = '400px';
exports.size400 = size400;
const size480 = '480px';
exports.size480 = size480;
const size500 = '500px';
exports.size500 = size500;
const size540 = '540px';
exports.size540 = size540;
const size580 = '580px';
exports.size580 = size580;
const size640 = '640px';
exports.size640 = size640;
const size660 = '660px';
exports.size660 = size660;
const size720 = '720px';
exports.size720 = size720;
const size800 = '800px';
exports.size800 = size800;
const size880 = '880px';
exports.size880 = size880;
const size960 = '960px';
exports.size960 = size960;
const size1280 = '1280px';
exports.size1280 = size1280;
const sizeFluid = '100%';
exports.sizeFluid = sizeFluid;
const sizeFullViewportHeight = '100vh';
exports.sizeFullViewportHeight = sizeFullViewportHeight;
const sizeFullViewportWidth = '100vw';
exports.sizeFullViewportWidth = sizeFullViewportWidth;